module.exports = __webpack_public_path__ + "img/logo.89235685.svg";